import React from 'react';
import { t } from './SiteChrome';
import MAP from './uaeMap.json';

/*
 * Peta jangkauan untuk /coverage: peta UAE dengan satu titik per emirat.
 *
 * SVG sebaris, tanpa dependensi, tanpa permintaan jaringan, tanpa kunci API,
 * tanpa cookie, tanpa tagihan. Batas emiratnya asli — Natural Earth 1:10m,
 * domain publik — sudah diproyeksikan dan disederhanakan ke uaeMap.json.
 *
 * Kenapa BUKAN poligon dari tabel Location: baris di situ zona dispatch, kotak
 * kecil hasil gambar tangan di Manage Location, totalnya di bawah 10% luas UAE.
 * Digambar apa adanya, situs jadi terlihat cuma melayani beberapa bercak —
 * membantah klaimnya sendiri di halaman yang sama.
 *
 * Nama emirat memakai kunci cov.* yang sudah ada, jadi peta ini ikut Arab tanpa
 * teks baru dan client bisa mengganti namanya dari dashboard seperti teks lain.
 */

const CoverageMap = ({ locale }) => {
  const tx = (k, v) => t(locale, k, v);

  return (
    <figure className="covmap">
      <svg viewBox={MAP.viewBox} role="img" width="100%" aria-label={tx('cvg.map.aria')}>
        <g className="covmap-land">
          {MAP.paths.map((d, i) => <path key={i} d={d} />)}
        </g>

        {MAP.pins.map(p => {
          const name = tx('cov.' + p.key);
          return (
            <g className="covmap-pin" key={p.key}>
              <title>{name}</title>
              {/* Bentuk pin digambar dari ujungnya ke atas, jadi (x,y) jatuh
                  tepat di kotanya — bukan di tengah ikon. */}
              <path className="covmap-pin-body"
                d={`M${p.x} ${p.y}c-7-9-11-13-11-18a11 11 0 0 1 22 0c0 5-4 9-11 18Z`} />
              <circle className="covmap-pin-dot" cx={p.x} cy={p.y - 18} r="4" />
              <text className="covmap-pin-lbl" x={p.x + p.dx} y={p.y + p.dy}
                style={{ textAnchor: p.anchor }}>{name}</text>
            </g>
          );
        })}
      </svg>

      <figcaption>{tx('cvg.figure')}</figcaption>
    </figure>
  );
};

export default CoverageMap;
